export default __webpack_public_path__ + "static/media/cash.9e187296.mp3";